/**
 * RAG retrieval defaults — single source of truth for server code
 * (LangChainService, KnowledgeBaseService) and UI (RAG settings dialog,
 * AI config dialog). Import-safe on the client: constants only.
 *
 * Precedence everywhere: agent-level `rag_settings` → use-case
 * `processing_config` → these defaults.
 *
 * threshold 0.3 — low end of the defensible range for text-embedding-3-small
 * cosine similarity. The old 0.1 effectively disabled the filter: with
 * `1 - distance > 0.1` nearly any chunk passes, so top-N arbitrary chunks got
 * injected under "Relevant Information" even when nothing relevant existed.
 * Reasoned starting point, not measured — revisit once a real embedded corpus
 * exists.
 */
export const RAG_DEFAULTS = {
  threshold: 0.3,
  limit: 5,
} as const
